
<div class="v-flex">
    <div>
        <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
                <a
                    v-on  = "{ ...tooltip }"
                    @click.stop="onClick"
                >
                    <v-icon
                        :color="active ? color : 'lightgray'"
                        :size="size"
                        class="toolbar-button"
                    >
                        {{ icon }}
                    </v-icon>
                </a>
            </template>
            <span>{{ name }}</span>
        </v-tooltip>
    </div>
</div>
